var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{staticClass:"mb-75",attrs:{"src":_vm.appLogoImage,"width":"60"}}),_c('p',{staticClass:"text-custom-blue-sky pl-1 mb-0 pt-2 d-inline-block",staticStyle:{"font-size":"22px"}},[_vm._v(_vm._s(_vm.appName))])])}
var staticRenderFns = []

export { render, staticRenderFns }